function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// ─────────────────────────────────────────────────────────────────────────────
// Constants
// ─────────────────────────────────────────────────────────────────────────────

var PRODUCT_PATHS = {
  wine: "wines",
  spirit: "spirits",
  "default": "products"
};

// ─────────────────────────────────────────────────────────────────────────────
// Helper Functions
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Safely extract physical items from LineItemMap as PhysicalItemT[]
 */
var getPhysicalItems = function getPhysicalItems(lineItems) {
  var _lineItems$physicalIt;
  if (!(lineItems !== null && lineItems !== void 0 && (_lineItems$physicalIt = lineItems.physicalItems) !== null && _lineItems$physicalIt !== void 0 && _lineItems$physicalIt.length)) return [];
  return lineItems.physicalItems;
};

/**
 * Build a URL with optional query parameters
 * @param baseUrl - The base URL without query string
 * @param params - Record of query parameters (falsy values are excluded)
 */
var buildUrl = function buildUrl(baseUrl, params) {
  var searchParams = new URLSearchParams();
  Object.entries(params).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (value) {
      searchParams.set(key, String(value));
    }
  });
  var queryString = searchParams.toString();
  return queryString ? "".concat(baseUrl, "?").concat(queryString) : baseUrl;
};

// ─────────────────────────────────────────────────────────────────────────────
// Item Type Checks
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Check if any item in the cart is NOT a spirit (i.e., wine or other product)
 * Used to determine which storefront host to use
 */
export var isAnyItemNotSpirit = function isAnyItemNotSpirit(lineItems) {
  var items = getPhysicalItems(lineItems);
  if (items.length === 0) return false;
  return items.some(function (item) {
    return item.isSpirit !== true;
  });
};

/**
 * Check if all items in the cart are wine (no spirits)
 * @returns true if cart contains only wine items, false if empty or contains spirits
 */
export var hasOnlyWineItems = function hasOnlyWineItems(lineItems) {
  var items = getPhysicalItems(lineItems);
  if (items.length === 0) return false;
  var spiritItems = items.filter(function (item) {
    return item.isSpirit === true;
  });
  return spiritItems.length === 0;
};

/**
 * Check if the cart contains at least one spirit item
 * Used to withhold Express shipping, which isn't offered for spirits
 */
export var hasAnySpiritItem = function hasAnySpiritItem(lineItems) {
  return getPhysicalItems(lineItems).some(function (item) {
    return item.isSpirit === true;
  });
};

/**
 * @deprecated Use hasOnlyWineItems instead
 */
export var isLineItemsPureWine = hasOnlyWineItems;

// ─────────────────────────────────────────────────────────────────────────────
// Storefront URL Functions
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Get the appropriate storefront host based on cart contents
 * - Returns WM_STOREFRONT_HOST for spirit-only carts (if configured)
 * - Returns STOREFRONT_HOST for wine/mixed carts or empty carts
 */
export var getStorefrontHost = function getStorefrontHost(lineItems) {
  var defaultHost = process.env.STOREFRONT_HOST || "";
  var wmHost = process.env.WM_STOREFRONT_HOST;
  if (!wmHost) return defaultHost;

  // Return default host for empty carts
  var items = getPhysicalItems(lineItems);
  if (items.length === 0) return defaultHost;
  return isAnyItemNotSpirit(lineItems) ? defaultHost : wmHost;
};

/** Per-item host picker for surfaces that only see one line item at a time
 * (e.g. Segment product mapping). Spirits route to WM when configured;
 * everything else routes to the default storefront. */
export var getStorefrontHostForItem = function getStorefrontHostForItem(item) {
  var defaultHost = process.env.STOREFRONT_HOST || "";
  var wmHost = process.env.WM_STOREFRONT_HOST;
  if (!wmHost) return defaultHost;
  return (item === null || item === void 0 ? void 0 : item.isSpirit) === true ? wmHost : defaultHost;
};

/** Build the storefront product URL for a single physical item using the
 * same per-type routing as `getLastItemProductUrl`:
 * - Spirits: `{host}/spirits/{category}/{slug}/`
 * - Gift:    `{host}/products/{slug}/`   (SKU contains "GIFT")
 * - Wines:   `{host}/wines/{slug}/`
 * If `storefrontHost` is omitted, the per-item picker is used. */
export var buildItemProductUrl = function buildItemProductUrl(item, storefrontHost) {
  var _item$sku;
  if (!(item !== null && item !== void 0 && item.slug)) return null;
  var host = storefrontHost !== null && storefrontHost !== void 0 ? storefrontHost : getStorefrontHostForItem(item);
  if (!host) return null;

  // Strip leading slash so the host + path join can't produce `//`.
  var productSlug = item.slug.replace(/^\//, "");
  if (item.isSpirit === true) {
    var _item$category;
    var spiritCategory = ((_item$category = item.category) === null || _item$category === void 0 ? void 0 : _item$category.toLowerCase()) || "";
    return "".concat(host, "/").concat(PRODUCT_PATHS.spirit, "/").concat(spiritCategory, "/").concat(productSlug, "/");
  }
  if ((_item$sku = item.sku) !== null && _item$sku !== void 0 && _item$sku.includes("GIFT")) {
    return "".concat(host, "/").concat(PRODUCT_PATHS["default"], "/").concat(productSlug, "/");
  }
  return "".concat(host, "/").concat(PRODUCT_PATHS.wine, "/").concat(productSlug, "/");
};

/**
 * Fallback "Back to Cart" URL when no last-item slug is available. Points at
 * the storefront homepage with `show_mini_cart=true` so the mini-cart still
 * opens on arrival. Used after the storefront's `/cart` and `/guest-checkout`
 * pages were retired.
 */
export var getStorefrontHomeUrl = function getStorefrontHomeUrl(lineItems, showMiniCart) {
  var storefrontHost = getStorefrontHost(lineItems);
  if (!storefrontHost) return "";
  return buildUrl(storefrontHost, {
    show_mini_cart: showMiniCart ? "true" : undefined
  });
};

/**
 * "Back to Cart" deep-link to the last item the shopper added. Uses the
 * cart-aware host pick (spirits-only carts route to WM) and delegates the
 * per-type routing to `buildItemProductUrl`. Relies on the Algolia-enriched
 * `slug` set by `replaceBigCommerceCartImages`.
 *
 * @returns Product URL or null if the cart is empty or the slug is missing.
 */
export var getLastItemProductUrl = function getLastItemProductUrl(lineItems, showMiniCart) {
  var items = getPhysicalItems(lineItems);
  if (items.length === 0) return null;
  var baseUrl = buildItemProductUrl(items[items.length - 1], getStorefrontHost(lineItems));
  if (!baseUrl) return null;
  return buildUrl(baseUrl, {
    show_mini_cart: showMiniCart ? "true" : undefined
  });
};